import React, { useState } from "react";
import { faq_data } from "../constants/common";

const Help = () => {

  const [chosen, setChosen] = useState(0)

  return (
    <div className="page-content px-xl-5">
      <div className="ms-0 px-5 py-5">
        <div className="col-12 col-lg-8 py-5">
          {
              faq_data.map((data, inx) => {
                return <div className="pt-4 pointer" key={`faq-${inx}`} onClick={() => setChosen(inx)} aria-expanded={inx === chosen}>
                  <div className="d-flex justify-content-between ps-2">
                      <h5 className={`font-size-16 font-weight-light ms-3 mb-0 ${inx === chosen ? 'text-black' : 'text-grey'}`}>{data.title}</h5>
                      <div className="position-relative">
                        <img height={"16px"} className={`position-absolute ${inx === chosen ? 'faq-icon--selected' : 'faq-icon'}`} src="images/faq_dropdown.svg" alt="dropdown"></img>
                        <img height={"16px"} className={`position-absolute ${inx === chosen ? 'faq-icon-orange--selected' : 'faq-icon-orange'}`} src="images/faq_dropdown_orange.svg" alt="dropdown"></img>
                      </div>
                  </div>
                  { inx === chosen ? <div className={`font-size-14 font-weight-light text-grey mt-2 ps-3 faq-content`}>
                      { data.description }
                    </div> : <div></div>
                  }
                  <div className="divider mt-4"></div>
                </div>
              })
            }
        </div>
      </div>
    </div>
  );
};

export default Help;
